export default __webpack_public_path__ + "static/media/api-token-two.7b296911.png";